import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import AuthService from '../service';

export default function Target() {
    const service = new AuthService()
    const unidadesByProfile = service.getProfile()?.unidadeList
    return (

        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Unidades (Metas de vendas)</TableCell>
                        <TableCell align="right">Pedidos</TableCell>
                        <TableCell align="right">Valor</TableCell>
                        <TableCell align="right">Ticket médio</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {unidadesByProfile.map((row) => (
                        <TableRow
                            key={row.idUnidade}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {row.nome}
                            </TableCell>
                            <TableCell align="right"></TableCell>
                            <TableCell align="right"></TableCell>
                            <TableCell align="right"></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>

    )

}